import { Heading } from 'components/Ui-Kits/Text'
import { auctionStatuses } from 'constants/publishedProduct'
import { arrayOf, object, string } from 'prop-types'
import { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { Item } from './Item'
import { useAppTranslation } from 'i18n/hooks'

export const ItemsList = ({ products, activeProductId }) => {
  const { t } = useAppTranslation()
  const scrollableDivWrap = useRef(null)
  const itemsRef = useRef([])

  useEffect(() => {
    const index = Math.max(products.findIndex(({ id }) => id === activeProductId) - 1, 0)
    if (!itemsRef.current[index]) return

    scrollableDivWrap.current.scrollTop = itemsRef.current[index].offsetTop
  }, [activeProductId, products])

  return (
    <Wrap>
      <Heading color="primary" size={1.25} mt={0} mb={0.75} bold>
        {t('currentItems')}
      </Heading>
      <RelativeWrap>
        <ScrollWrap ref={scrollableDivWrap}>
          {products.map((product, i) => (
            <Item
              active={product.id === activeProductId}
              key={product.id}
              image={product?.featuredImage?.url}
              slotNumber={product.sort + 1}
              total={products.length}
              startingPrice={product?.technicalDetails?.AuctionMinimumPrice}
              ref={el => (itemsRef.current[i] = el)}
              disabled={product.auctionStatus === auctionStatuses.DISABLED}
            />
          ))}
        </ScrollWrap>
      </RelativeWrap>
    </Wrap>
  )
}

ItemsList.propTypes = {
  products: arrayOf(object).isRequired,
  activeProductId: string,
}

const Wrap = styled.div`
  position: relative;
  width: 100%;
  min-height: 400px;
  background-color: var(--color-grey);
  box-sizing: border-box;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  @media screen and (min-width: 760px) {
    width: 33%;
    width: calc(34% - 1.5rem);
  }
`
const ScrollWrap = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: scroll;
  box-sizing: border-box;
`

const RelativeWrap = styled.div`
  position: relative;
  flex: 1;
`
